import React, { useState, useEffect } from 'react';
import { Toolbar, Typography, Tab, Tabs, useMediaQuery, Box } from '@mui/material';
import { ThemeProvider, useTheme } from '@mui/material/styles';
import ExperienceList from './ExperienceList';
import ExperienceApprovalList from './ExpApprovalList';
import { mainTheme, tabThemeAdmin } from '../../TabsCore';
import { PerChk } from '../../../common/Common';

export default function ExperienceManagementTab() {
    const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'));
    const [tabIndex, settabIndex] = useState('0');
    const isExpListHidden = PerChk('EXPERIENCE_LIST');
    const isApprovalListHidden = PerChk('EXPERIENCE_APPROVALLIST');

    useEffect(() => {
        if (isExpListHidden && !isApprovalListHidden) {
            settabIndex('1');
        } else if (isExpListHidden && isApprovalListHidden) {
            settabIndex(null);
        }
    }, [isExpListHidden, isApprovalListHidden]);

    if (isExpListHidden && isApprovalListHidden) {
        return null;
    }



    return (<ThemeProvider theme={mainTheme}><Box sx={{ display: 'flex', flexDirection: 'column' }}>

        <Toolbar sx={{ display: 'flex', justifyContent: 'center', alignItems: 'right', bgcolor: '#1px solid grey', p: 2, height: '20px', top: 0, zIndex: 99 }}>
            <ThemeProvider theme={tabThemeAdmin}>
                <Box sx={{ width: '100%' }}>
                    <Tabs value={tabIndex} onChange={(e, ti) => settabIndex(ti)}>
                        {!isExpListHidden && <Tab value="0" label="Experience List" />}
                        {!isApprovalListHidden && <Tab value="1" label="Approval" />}
                    </Tabs>
                </Box>
            </ThemeProvider>
        </Toolbar>

        <Box>
            {!isExpListHidden && tabIndex === '0' && <ExperienceList />}
            {!isApprovalListHidden && tabIndex === '1' && <ExperienceApprovalList />}
        </Box>
    </Box ></ThemeProvider >)
}	